import { withThemeProvider } from '@features/branding/withThemeProvider';
import { withLocalizationProvider } from '@features/localization';
import compose from 'lodash/fp/compose';

import EventParts from './event-parts-component';

export default compose(withThemeProvider, withLocalizationProvider)(EventParts);
